function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP state of issue
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { stateOfIssue } from '../../actions/index';
import Select from '../select/Select';
import { STATES } from '../../data/Data';
import './StateOfIssue.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export class StateOfIssue extends React.Component {
  render() {
    const {
      stateOfIssue,
      setStateOfIssue
    } = this.props;
    return /*#__PURE__*/_jsx(Select, {
      handleChange: setStateOfIssue,
      label: "State of issue",
      options: STATES,
      onBlur: setStateOfIssue,
      name: "stateOfIssue",
      section: "licence-details"
      // $FlowFixMe
      ,
      values: {
        stateOfIssue
      }
    });
  }
}
_defineProperty(StateOfIssue, "defaultProps", {
  stateOfIssue: {
    value: ''
  }
});
const mapStateToProps = ({
  stateOfIssue
}) => {
  return {
    stateOfIssue
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setStateOfIssue: value => {
      dispatch(stateOfIssue(value));
    }
  };
};
const VisibleStateOfIssue = connect(mapStateToProps, mapDispatchToProps)(StateOfIssue);
export default VisibleStateOfIssue;